import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import notify from 'devextreme/ui/notify';

/**
 * Handles deep links to records hidden by the backend tenant scope. When a GET
 * for a specific component record (a `/api/component/.../<id>` detail endpoint)
 * comes back 404/403 — which is how the tenant scope hides an out-of-tenant or
 * non-existent record — show a generic "not available" notice and route the
 * user to Startseite, without distinguishing "does not exist" from "belongs to
 * another tenant" (so cross-tenant existence is never leaked).
 *
 * Scoped to record-detail GETs so it does not interfere with other 404/403
 * handling; the error is rethrown so existing per-call handling still runs.
 */
@Injectable()
export class WrongTenantInterceptor implements HttpInterceptor {
  private static readonly DETAIL_URL = /\/api\/component\/[^?]*\/\d+(\?|$)/;

  constructor(private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (this.isHiddenRecordDeepLink(req, error)) {
          notify(
            'Dieser Eintrag ist nicht verfügbar.',
            'warning',
            4000
          );
          this.router.navigate(['/procedural-instructions/dashboard']);
        }
        return throwError(() => error);
      })
    );
  }

  private isHiddenRecordDeepLink(
    req: HttpRequest<any>,
    error: HttpErrorResponse
  ): boolean {
    return (
      req.method === 'GET' &&
      (error.status === 404 || error.status === 403) &&
      WrongTenantInterceptor.DETAIL_URL.test(req.url)
    );
  }
}
